import React, { useContext } from 'react';
import type { HTMLAttributes } from 'react';
import { PdfContext } from '../../../context/PdfContext';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends HTMLProps {
  filterSelector: React.ReactNode;
  timeRangeSelector: React.ReactNode;
  viewTypeToggle?: React.ReactNode;
  downloadHandler?: React.ReactNode;
  manageMetricsHandler?: React.ReactNode;
  hideDownloadButton?: boolean;
}

const Settings = ({
  filterSelector,
  timeRangeSelector,
  viewTypeToggle,
  manageMetricsHandler,
  downloadHandler,
  hideDownloadButton = false,
  ...other
}: Props): JSX.Element => {

  const { isPdf } = useContext(PdfContext);

  return (
    <div {...other as HTMLProps}>
      <div className={`${isPdf ? 'flex' : 'container'} md:flex items-center justify-between py-0.5`}>
        <div className={'mb-sm md:mb-0'}>
          {filterSelector}
        </div>
        <div className={'mb-sm md:mb-0'}>
          {timeRangeSelector}
        </div>
        {viewTypeToggle && !isPdf && (
          <div className={'mb-sm md:mb-0 flex items-center space-x-2'} data-hide-print>
            <div>{viewTypeToggle}</div>
            <div>{manageMetricsHandler}</div>
          </div>
        )}
        {!hideDownloadButton && (
          <div>
            {downloadHandler}
          </div>
        )}
      </div>
    </div>
  );
};

Settings.displayName = 'Settings';

export default Settings;
